import React from "react"; 
import SignUpForm from "../../mycomp/Authentication/SignUpForm";

const SignUp = () => {
  return (
    <>
      <SignUpForm />
    </>
  );
};

export default SignUp;
